module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "1000"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [(_vm.isRemark) ? _c('v-card-title', {
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("CC Remarks for @" + _vm._s(_vm.handle))])]) : _c('v-card-title', {
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Campaign Lists for @" + _vm._s(_vm.handle))]), _vm._v(" "), (_vm.emptyCampaigns) ? _c('span', {
    staticStyle: {
      "color": "grey",
      "font-size": "12px"
    }
  }, [_vm._v("(" + _vm._s(_vm.emptyCampaigns) + ") Campaigns Not Found")]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "campaign-lists-table elevation-1",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.items,
      "items-per-page": 10,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "item.pairingDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "100px"
          }
        }, [_vm._v("\n                  " + _vm._s(item.pairingDate) + "\n                ")])])]
      }
    }, {
      key: "item.isArchive",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.archive) ? _c('span', [_vm._v("YES")]) : _c('span', [_vm._v("NO")])])])]
      }
    }, {
      key: "item.deliverables",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  " + _vm._s(_vm.campaignHelper.getDeliverableDetails(item.deliverables)) + "\n                ")])])]
      }
    }, {
      key: "item.payout",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  $ " + _vm._s(_vm._f("thousandSeprator")(item.payout)) + "\n                ")])])]
      }
    }, {
      key: "item.ccRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "color": "black",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.ccRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.ccRemarks))
          }
        })])], 1)])]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-285fb41d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/PairedCreators/CampaignListsModal.vue
// module id = 2048
// module chunks = 0